import React from 'react'
import LazyLoad from 'react-lazyload'
import PlImage from '../media/images/plastyke_small.jpg'
import CookImage from '../media/images/mali-kucharze-mobile.jpg'
import RythImg from '../media/images/rytmika_small.jpg'
import SensoImg from '../media/images/sensoplastyka_small.jpg'
import PlayImg from '../media/images/zabawy-na-powietrzu_small.jpg'

const Image = props => {
  const { src, alt } = props
  return (
    <LazyLoad height={100} throttle={200}>
      <img
        className="album-img"
        src={src}
        alt={alt}
      />
    </LazyLoad>
  )
}


const ActivitiesHomPage = () => (
  <div>
    <div className="col-sm-6 col-md-4">
      <div className="thumbnail">
        <Image src={PlImage} alt="Plastyka" />
        <div className="caption">
          <h3>
            Plastyka
          </h3>
          <p>
            Rozwijanie uzdolnień i zainteresowań artystycznych dzieci oraz ich wrodzonych możliwości twórczych…
          </p>
          <p>
            <a
              href="/plastyka"
              className="btn"
              role="button"
              style={{
                background: '#21c1d3',
                color: '#ffffff',
              }}
            >
              Czytaj więcej
            </a>
          </p>
        </div>
      </div>
    </div>
    <div className="col-sm-6 col-md-4">
      <div className="thumbnail">
        <Image src={CookImage} alt="Mali kucharze" />
        <div className="caption">
          <h3>
            Mali Kucharze
          </h3>
          <p>
            Mali kucharze to zajęcia kulinarne dostosowane do wieku dzieci. Dzięki nim dzieci będą poznawały nowe…
          </p>
          <p>
            <a
              href="/mali-kucharze"
              className="btn"
              role="button"
              style={{
                background: '#e23664',
                color: '#ffffff',
              }}
            >
              Czytaj więcej
            </a>
          </p>
        </div>
      </div>
    </div>
    <div className="col-sm-6 col-md-4">
      <div className="thumbnail">
        <Image src={RythImg} alt="Rytmika" />
        <div className="caption">
          <h3>
            Rytmika
          </h3>
          <p>
            Zajęcia muzyczno-ruchowe odgrywają dużą rolę w lepszym funkcjonowaniu emocjonalnym intelektualnym i fizycznym w przyszłości…
          </p>
          <p>
            <a
              href="/rytmika"
              className="btn"
              role="button"
              style={{
                background: '#dba21e',
                color: '#ffffff',
              }}
            >
              Czytaj więcej
            </a>
          </p>
        </div>
      </div>
    </div>
    <div className="col-sm-6 col-md-4">
      <div className="thumbnail">
        <Image src={SensoImg} alt="Sensoplastyka" />
        <div className="caption">
          <h3>
          Sensoplastyka
          </h3>
          <p>
          Sensoplastyka daje dzieciom możliwość poznawania nowych form wyrazu i działań artystycznych…
          </p>
          <p>
            <a
              href="/sensoplastyka"
              className="btn"
              role="button"
              style={{
                background: '#624dd6',
                color: '#ffffff',
              }}
            >
              Czytaj więcej
            </a>
          </p>
        </div>
      </div>
    </div>
    <div className="col-sm-6 col-md-4">
      <div className="thumbnail">
        <Image src={PlayImg} alt="Zabawy na świeżym powietrzu" />
        <div className="caption">
          <h3>
          Zabawy na świeżym powietrzu
          </h3>
          <p>
          Dzieci będą spędzały czas na świeżym powietrzu podczas codziennych spacerów oraz zabawy na bezpiecznym…
          </p>
          <p>
            <a
              href="/zabawy-na-powietrzu"
              className="btn"
              role="button"
              style={{
                background: '#996',
                color: '#ffffff',
              }}
            >
              Czytaj więcej
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
)

export default ActivitiesHomPage
